import { BuyerStatusType, NestedBuyer, NestedSearch } from "@habity/types";
import {
  getLivingSpace,
  getMonthlyFee,
  getPlotSize,
  getRooms,
  getBedrooms,
} from "./addresses";

export const getBuyerStatus = (status: BuyerStatusType) => {
  const swedishTypes = {
    activelyLooking: "Letar omgående",
    planningToBuy: "Letar på sikt",
    justCurious: "Bara nyfiken",
  };
  return swedishTypes[status];
};

export const getBuyerStatusColor = (status: BuyerStatusType) => {
  const swedishTypes = {
    justCurious: "#38B2AC",
    planningToBuy: "#4299E1",
    activelyLooking: "#9F7AEA",
  };
  return swedishTypes[status];
};

export const getBuyerStatusDescription = (status: BuyerStatusType) => {
  const swedishTypes = {
    justCurious: "Utforskar bostäder i aktuellt område",
    planningToBuy: "Vill köpa en ny bostad när rätt möjlighet ges",
    activelyLooking: "Vill köpa en ny bostad omgående",
  };
  return swedishTypes[status];
};

export const formatHomebuyerData = (buyer: NestedBuyer) => {
  const { search } = buyer;
  const {
    living_space_min,
    living_space_max,
    plot_size_min,
    plot_size_max,
    rooms_min,
    rooms_max,
    bedrooms_min,
    bedrooms_max,
    // categories,
    // price_min,
    // price_max,
    monthly_fee_min,
    monthly_fee_max,
  } = search || {};
  const data: string[] = [];
  // if (categories)
  //   data.push(
  //     categories
  //       .map((c) => getCategoryText(c as CategoryType))
  //       .join(', ') + ' sökes'
  //   );
  if (rooms_min) data.push(`minst ${getRooms(rooms_min)}`);
  if (rooms_max) data.push(`max ${getRooms(rooms_max)}`);
  if (bedrooms_min) data.push(`minst ${getBedrooms(bedrooms_min)}`);
  if (bedrooms_max) data.push(`max ${getBedrooms(bedrooms_max)}`);
  // if (price_min) data.push(`minst ${getPrice(price_min)}`);
  // if (price_max) data.push(`max ${getPrice(price_max)}`);
  if (living_space_min) data.push(`minst ${getLivingSpace(living_space_min)}`);
  if (living_space_max) data.push(`max ${getLivingSpace(living_space_max)}`);
  if (plot_size_min) data.push(`minst ${getPlotSize(plot_size_min)}`);
  if (plot_size_max) data.push(`max ${getPlotSize(plot_size_max)}`);
  if (monthly_fee_min) data.push(`minst ${getMonthlyFee(monthly_fee_min)}`);
  if (monthly_fee_max) data.push(`max ${getMonthlyFee(monthly_fee_max)}`);

  return data.join(" • ");
};
